import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useUploadBrandLogoMutation = () =>
  useTypedMutation<FormData, string>({
    mutationFn: async formData => (await ApiInstance.post("/brands/logo/upload", formData, ENV.carBaseURL)).data.url,
    onSuccess: () => null
  });
